// Suppression predicate for the legacy InChatFlightSearchResult ERROR block on a
// streamed clarifying turn.
//
// Case (and ONLY this case): the in-chat search-progress stream ran but carried
// only status messages — no result cards — AND the flight search came back with a
// user-input (4xx) error. That happens when the assistant needs more info (e.g.
// "I need your return date to complete the roundtrip search") and the turn fired a
// doomed search anyway. The assistant's chat text already explains what it needs,
// so the legacy "✈ Flights — We couldn't search for flights right now" block is
// redundant noise. Hide it in that exact combination.
//
// Deliberately narrow (minimal blast radius). UNAFFECTED:
//   • successful searches (cards present — the error branch never renders),
//   • non-streamed flight turns → error shows as before,
//   • transient 5xx errors → stay visible so the user knows to retry,
//   • hotel results.
export function isStreamedFlightClarifyError(entry: {
  flightResponse?: { error?: unknown; errorStatus?: unknown } | null;
  searchProgressMessagesOnly?: boolean;
  searchProgress?: { cards?: unknown[] } | null;
}): boolean {
  const fr = entry?.flightResponse;
  if (typeof fr?.error !== "string") return false;

  const sp = entry?.searchProgress;
  const messagesOnly =
    entry?.searchProgressMessagesOnly === true ||
    (!!sp && !(Array.isArray(sp.cards) && sp.cards.length > 0));
  if (!messagesOnly) return false;

  // Only user-input (4xx) errors — i.e. the refine-able / incomplete-query case.
  // 5xx (transient) stays visible.
  const status = fr?.errorStatus;
  return typeof status === "number" && status >= 400 && status < 500;
}
